//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "./components/header";
import Footor from "./components/footer";
import { wxName, setSession, getSession } from "./utils/config";
export default {
  name: "app",
  components: {
    Header,
    Footor,
  },
  data() {
    return {
      index: 0,
      headerIndex: 0,
      isShow: false, // 展示footer
      isShowHead: false, // 展示header
      i: 0,
      scrollDirection: "",
    };
  },
  created() {
    // this.headerIndex = this.$store.getters.gethomeTopTab
  },
  watch: {
    $route(to) {
      document.title = to.meta.title;
      if (to.fullPath === "/my") {
        this.index = 3;
        this.isShowHead = false;
        this.isShow = true;
      } else if (to.fullPath === "/found") {
        this.index = 2;
        this.isShow = true;
        this.isShowHead = false;
      } else if (to.path === "/travel") {
        this.index = 1;
        this.isShowHead = false;
        this.isShow = true;
      } else if (to.path === "/home") {
        this.index = 0;
        this.headerIndex = 0;
        this.isShow = true;
        this.isShowHead = true;
      } else if (to.fullPath === "/cardList") {
        this.isShow = true;
        this.isShowHead = true;
        this.headerIndex = 1;
        this.index = 0;
      } else if (to.fullPath === "/infomation") {
        this.isShow = true;
        this.isShowHead = true;
        this.headerIndex = 2;
        this.index = 0;
      } else if (to.fullPath === "/plan") {
        this.isShow = true;
        this.isShowHead = true;
        this.headerIndex = 3;
        this.index = 0;
      } else if (to.fullPath === "/order") {
        this.isShow = true;
        // this.isShowHead = true;
        this.headerIndex = 3;
        this.index = 4;
      } else {
        this.isShowHead = false;
        this.isShow = false;
      }
    },
  },
  computed: {},
  mounted() {
    let weChatName = this.GetRequest("wxName");
    if (!weChatName) {
      weChatName = wxName;
    }
    setSession("wxName", { name: weChatName });
    // console.log("111111111111:", getSession("wxName").name);
    this.phoneType();
    this.$isWx = this.getIsWxClient();
    if (this.isAndroid() && this.$isWx) {
      this.adjustFont();
    }
  },
  methods: {
    /**
     * 判断是否是微信环境
     */
    getIsWxClient() {
      let ua = navigator.userAgent.toLowerCase();
      if (String(ua.match(/MicroMessenger/i)) === "micromessenger") {
        return true;
      }
      return false;
    },
    phoneType() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 这个判断 是不是ios手机
      var flag;
      var myFunction;
      if (isiOS) {
        // 既是微信浏览器 又是ios============（因为查到只有在微信环境下，ios手机上才会出现input失去焦点的时候页面被顶起）
        document.body.addEventListener("focusin", () => {
          // 软键盘弹起事件
          flag = true;
          clearTimeout(myFunction);
        });
        document.body.addEventListener("focusout", () => {
          // 软键盘关闭事件
          flag = false;
          if (!flag) {
            myFunction = setTimeout(function () {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // 重点  =======当键盘收起的时候让页面回到原始位置
            }, 100);
          }
        });
      } else {
      }
    },
    scrollEvent() {
      let that = this;
      that.isShow = true;
      document.getElementById("app").onscroll = function () {
        let scrollTop = document.getElementById("app").scrollTop;
        let scroll = scrollTop - that.i;
        that.i = scrollTop;
        if (scroll < 0) {
          if (!that.isShow) {
            that.isShow = true;
          }
        } else {
          if (that.isShow) {
            that.isShow = false;
          }
        }
      };
    },
    GetRequest(name) {
      let search = document.location.search;
      let pattern = new RegExp("[?&]" + name + "=([^&]+)", "g");
      let matcher = pattern.exec(search);
      let items = null;
      if (matcher != null) {
        try {
          items = decodeURIComponent(decodeURIComponent(matcher[1]));
        } catch (e) {
          try {
            items = decodeURIComponent(matcher[1]);
          } catch (e) {
            items = matcher[1];
          }
        }
      }
      return items;
    },
    isAndroid() {
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 这个判断 是不是ios手机
      return !isiOS;
    },
    adjustFont() {
      if (
        typeof WeixinJSBridge === "object" &&
        typeof WeixinJSBridge.invoke === "function"
      ) {
        this.handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.handleFontSize,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.handleFontSize);
          document.attachEvent("onWeixinJSBridgeReady", this.handleFontSize);
        }
      }
    },
    handleFontSize() {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/App.vue